import { buildUri } from '../../endpoints';

/**
 * A general utility class for Chameleon courses.
 */
export class ScormChameleonUtils {

    /**
     * The theme keys used to pass into the URL of a Chameleon course when opening it. This
     * is how we can control the theme displayed inside of the course itself. These themes
     * are defined inside of Chameleon.
     */
    static themeKey = {
        HOYA: 'hoya',
        SEIKO: 'seiko',
    };

    /**
     * Returns the entry path for the course. This is the path used to open the course.
     * 
     * @param { object } path - The initial path to access the course.
     * @param { object } options - Additional data to store in the built path to change course behaviors.
     * @returns { string }
     */
    static buildEntryPath( path, { localeCode, themeKey } = {} ) {
        if ( path && typeof path == 'string' ) {
            // Build the entry path for the Chameleon course using some possible query string params.
            return buildUri( path, {}, { theme: themeKey, language: localeCode } );
        }
        else {
            return undefined;
        }
    }

    /**
     * Returns whether or not the provided entry path to the course is recognized as a
     * Chameleon entry path.
     * 
     * @param { string } path - The path to access the entry point to the file. Used to open and launch the course.
     * @returns { boolean }
     */
    static isValidEntryPath( path ) {
        return ( path?.indexOf( 'index.html' ) >= 0 );
    }

}
